// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__7DLWA","addWidgetButton":"Header_addWidgetButton__1VmbL","dashboardTabs":"Header_dashboardTabs__1Klxq","active":"Header_active__QKq-x"};